import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Select, Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const Queryss = () => {
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },
    {
      title: "DataBase",
      dataIndex: "Database",
      sorter: (a, b) => a.Database - b.Database,
    },
    {
      title: "SqlQuery",
      dataIndex: "SqlQuery",
      sorter: (a, b) => a.SqlQuery - b.SqlQuery,
      render: (text) => (
        <span title={text}>
          {text?.length > 30 ? text.substring(0, 30) + "..." : text}
        </span>
      ),
    },
    {
      title: "QryType",
      dataIndex: "QryType",
      sorter: (a, b) => a.QryType.localeCompare(b.QryType),
    },

    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#device_detail"
            onClick={() => fetchDetails(record)}
          >
            <i className="ti ti-eye" />
          </Link>

          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
            onClick={() => handleDelete(record)}
          >
            <i className="ti ti-trash" />
          </Link>

          <Link
            to="/queryExecute"
            state={{ record }}
            className="p-2 d-flex align-items-center border rounded me-2"
          >
            <i className="ti ti-player-play" />
          </Link>
        </div>
      ),
    },
  ];

  const [organizations, setOrganizations] = useState([]);
  const [selectedDatabase, setSelectedDatabase] = useState(null);

  const [modalData, setModalData] = useState([]);
  const [dbData, setDbData] = useState([]);

  const [modelLoading, setModelLoading] = useState(false);

  const [addForm, setAddForm] = useState({
    Name: "",
    Database: "",
    SqlQuery: "",
    QryType: "",
    SuperId: "",
  });

  const resetAddForm = () => {
    setAddForm({
      Name: "",
      Database: "",
      SqlQuery: "",
      QryType: "",
      SuperId: "",
    });
  };

  const QueryType1 = [
    { value: "Select", label: "Select" },
    { value: "Insert", label: "Insert" },
    { value: "Update", label: "Update" },
    { value: "Delete", label: "Delete" },
  ];

  const saveNewQuery = async () => {
    try {
      const payload = {
        Name: addForm.Name,
        Database: addForm.Database,
        SqlQuery: addForm.SqlQuery,
        QryType: addForm.QryType,
      };

      const res = await axios.post(`${API_BASE_URL}/api/addquery`, payload);

      if (res.data?.Status) {
        Swal.fire("Success", "Query added!", "success");
        fetchByDatabase(selectedDatabase.value); // refresh table
        console.log(selectedDatabase.value, "vxhavhxbhjgbxnan");
        resetAddForm(); // clear form
        document.getElementById("closeModel").click();
      } else {
        Swal.fire("Error", res.data?.ResultMessage || "Failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const getQuerys = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getdbquery`);
      const data = response.data?.ResultData || [];

      const mappedOptions = data.map((item) => ({
        value: item.Database,
        label: item.Database,
      }));

      setOrganizations(mappedOptions);

      if (mappedOptions.length > 0) {
        setSelectedDatabase(mappedOptions[0]); // ✅ only set state
      }
    } catch (error) {
      console.error("Error fetching databases:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchByDatabase = async (dbName) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getbydatabase?database=${encodeURIComponent(dbName)}`,
      );

      const result = response.data?.ResultData || [];
      setDbData(result); // <-- fill table
    } catch (error) {
      console.error("Error fetching DB query list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDetails = (record) => {
    setModelLoading(true);

    // Suppose record itself has all details
    setModalData(record);

    setModelLoading(false);
  };

  const handleAddChange = (e) => {
    setAddForm({
      ...addForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleDelete = (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete "${record.Name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(`${API_BASE_URL}/api/querydelete`, {
            method: "POST", // or "DELETE"
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ Id: String(record.Id) }),
          });

          console.log(record.Id, "xbcjknaj xnjsnxcknx");

          const data = await res.json();

          if (data.ResultData[0].Status === "1") {
            Swal.fire("Deleted!", "Record has been deleted.", "success");
            fetchByDatabase(selectedDatabase.value);
          } else {
            Swal.fire(
              "Failed!",
              data.ResultMessage || "Unable to delete record.",
              "error",
            );
          }
        } catch (err) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  useEffect(() => {
    getQuerys();
  }, []);
  useEffect(() => {
    const modal = document.getElementById("add_plans");

    const handleClose = () => {
      resetAddForm();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  useEffect(() => {
    if (selectedDatabase?.value) {
      fetchByDatabase(selectedDatabase.value);
    }
  }, [selectedDatabase]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Querys</h4>
                <h6>Manage your Database Querys</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li> */}
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
              >
                <i className="ti ti-circle-plus me-1"></i>
                Add
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <div className="search-set"></div>

              <div className="dropdown me-3">
                <Select
                  style={{ width: 200 }}
                  placeholder="Select Database"
                  options={organizations}
                  value={selectedDatabase}
                  onChange={(val) => {
                    setSelectedDatabase(val);
                    fetchByDatabase(val);
                    console.log(val, "hjsvahcxvvasbxhgzcxvxhgvghvxggvcxgchc");
                  }}
                />
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      rowKey={(record, index) => index}
                      columns={columns}
                      dataSource={dbData}
                      pgno={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* view model */}
      <div className="modal fade" id="device_detail">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="text-gray-9 fw-medium">Query Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              {modelLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: 150 }}
                >
                  <Spin size="large" />
                </div>
              ) : modalData ? (
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="fw-bold">Name:</label>
                    <p>{modalData.Name || "N/A"}</p>
                  </div>

                  <div className="col-md-3">
                    <label className="fw-bold">Database:</label>
                    <p>{modalData.Database || "N/A"}</p>
                  </div>

                  <div className="col-md-3">
                    <label className="fw-bold">QueryType</label>
                    <p>{modalData.QryType || "N/A"}</p>
                  </div>

                  <div className="col-md-12">
                    <label className="fw-bold">SqlQuery</label>
                    <p>{modalData.SqlQuery || "N/A"}</p>
                  </div>
                </div>
              ) : (
                <p className="text-center text-muted">
                  No device details available
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* add model */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Query</h4>
              <button
                id="closeModel"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                {/* Query Name */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Query Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Name"
                      value={addForm.Name}
                      onChange={handleAddChange}
                      placeholder="Enter Query Name"
                    />
                  </div>
                </div>

                {/* superId */}
                {/* <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      SuperId <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="SuperId"
                      value={addForm.SuperId}
                      onChange={handleAddChange}
                      placeholder="Enter SuperId"
                    />
                  </div>
                </div> */}

                {/* Database Dropdown */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Database <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="w-100"
                      style={{ height: "40px" }}
                      placeholder="Select Database"
                      options={organizations}
                      value={addForm.Database}
                      onChange={(value) =>
                        setAddForm({ ...addForm, Database: value })
                      }
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>
                </div>

                {/* QryType */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Query Type <span className="text-danger">*</span>
                    </label>
                    {/* <Select
                      className="w-100"
                      style={{ height: "40px" }}
                      options={QueryType1} // e.g., [{label:"Lite", value:"Lite"}]
                      value={addForm.QryType}

                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    /> */}
                    <Select
                      className="w-100"
                      style={{ height: "40px" }}
                      options={QueryType1}
                      value={addForm.QryType}
                      onChange={(value) =>
                        setAddForm({ ...addForm, QryType: value })
                      }
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>
                </div>

                {/* Sql Query */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      SQL Query <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={4}
                      name="SqlQuery"
                      value={addForm.SqlQuery}
                      onChange={handleAddChange}
                      placeholder="Enter SQL Query"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-light" data-bs-dismiss="modal">
                Cancel
              </button>

              <button className="btn btn-primary" onClick={saveNewQuery}>
                Save Query
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Queryss;
